import empty from "../../../assets/images/common/emty.svg";
import "./style.css";
import React from "react";
import {EmptyProps} from "./Empty.props";

export default function Empty(props: EmptyProps) {
    return (
        <div className="common-empty">
            <img src={empty} alt="not"/>
            <div className="text" data-testid="message-text">
                {props.messageText}
            </div>
            {
                props.buttonText && (
                    <button className="add-btn" onClick={props.handleButtonClick} data-testid="button-text">
                        {props.buttonText}
                    </button>
                )
            }
        </div>
    )
}